export const environment = {
  production: true,
  orderApi: 'https://pagos.ordenaris.com'
};

